<template>
  <div class="container" style="padding: 0px; margin-bottom: 30px;">
    <div class="row">
      <div class="col-md-12">
        <b-alert show dismissible>
          Check your email shortly for your order confirmation.
        </b-alert>
      </div>
    </div>

    <div v-if="purchase !== null" class="row no-gutters has-map fixed event-show-image-description"
      style="transform: none;">
      <div class="col-md-6">
        <div class="card card-standard">
          <h4>
            <strong>Order Summary</strong>
          </h4>

          <h6>
            Order #{{ purchase.order_number }} - {{ purchase.purchase_date }}
          </h6>

          <div class="media mt-0 mb-4">
            <div class="media-body">
              {{ user.first_name + ' ' + user.last_name}} <br/>
              {{ user.email }}
            </div>
          </div>

          <table class="table table-borderless">
            <tbody>
              <tr>
                <td>
                  <i class="fa fa-gift" aria-hidden="true"></i>
                  {{ purchase.gift_card_title }}
                </td>
                <td v-if="giftCard.limited_time_bonus_enabled && !giftCard.limited_time_bonus_out_of_date" class="text-right"> {{ totalWithBonusPrice() | currency }} </td>
                <td v-else class="text-right">{{ purchase.formatted_amount }} </td>
              </tr>
            </tbody>
            <tfoot class="standard-tfoot-purchase-confirmation-table">
              <tr>
                <td colspan="2" class="text-right">
                  <b>{{ purchase.formatted_amount }}</b>
                </td>
              </tr>
            </tfoot>
          </table>

          <div v-if="purchase.amount > 0">

            <div class="media mt-0">
              <div class="media-body">
                Charged to the {{ getCardVendor() }} card ending in *{{ getCardLast4() }}
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card card-standard card-standard-headers" style="background-color: #3B3630; color: #fff;">
          <div class="media mt-0 mb-3">
            <div class="media-body" v-html="markedText(this.giftCard.purchase_message)">
            </div>
          </div>

          <b-row class="mt-auto">
            <b-col cols="12" lg="6" md="6" sm="12" xs="12">
              <a :href="`mailto:${giftCard.organizer_contact_email || giftCard.owner_email}`"
                class="btn btn-lg btn-primary btn-block">
                Contact us
              </a>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <div v-if="purchase !== null" class="row">
      <div class="col-md-12">
        <div class="mt-3">
          Thanks! <br/>
          {{ giftCard.organizer_name }}
        </div>

        <div v-if="giftCard.organizer_website" class="mt-1">
          <a :href="giftCard.organizer_website" target="_blank">
            {{giftCard.organizer_website }}
          </a>
        </div>

        <div v-if="giftCard.organizer_contact_phone_number" class="mt-1">
          <a :href="`tel:+1${extracNumbers(giftCard.organizer_contact_phone_number)}`"
            rel="nofollow">
            {{ giftCard.organizer_contact_phone_number }}
          </a>
        </div>
      </div>
    </div>

    <div v-if="purchase === null || purchase === undefined" class="row justify-content-md-center">
      <div class="col col-lg-8">
        <div class="error-template text-center">
          <i class="fa fa-exclamation-triangle fa-5x text-danger animated zoomIn mb50 mt50" />
          <h3 class="main-title">
            <span>Oops! Purchase Not Found</span>
          </h3>
          <div class="main-title-description">
            Sorry, the purchase that you are looking for does not exist.
          </div>
          <div class="error-actions">
            <a href="/gift-cards" class="btn btn-primary btn-lg ml-2 mr-2 mb-3">
              Go to Gift Cards
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GiftCardPurchaseConfirmation',
  data () {
    return {
      purchase: {},
      user: {},
      giftCard: {
        purchase_message: ''
      },
      giftCardCode: {},
      paymentInformation: {},
      orderNumber: this.$route.params.order_number
    }
  },
  created () {
    this.loadPurchase()
  },
  methods: {
    loadPurchase () {
      const self = this
      const purchaseLoader = this.$loading.show()

      this.$http.get('/public_access/purchases/' + this.orderNumber).then(function (response) {
        self.purchase = response.data
        self.user = self.purchase.user
        self.giftCard = self.purchase.gift_card
        self.giftCardCode = self.purchase.gift_card_code
        self.paymentInformation = (self.purchase.payment_intents || []).pop()
      }).catch(function (error) {
        if (error) {
          self.purchase = null
        }
      }).finally(function () {
        purchaseLoader.hide()
      })
    },
    getCardVendor () {
      return this.paymentInformation && this.paymentInformation.token_information &&
        this.paymentInformation.token_information.card.brand
    },
    getCardLast4 () {
      return this.paymentInformation && this.paymentInformation.token_information &&
        this.paymentInformation.token_information.card.last4
    },
    totalWithBonusPrice () {
      return (this.calculateBonusPrice(this.purchase.amount, this.giftCard.bonus_percentage) + (this.purchase.amount / 100)).toFixed(2)
    }
  }
}
</script>
